exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-28c1a3bf] {\n  pointer-events: none;\n\n  position: fixed;\n  right: 0;\n}\nsvg polygon[data-v-28c1a3bf],\nsvg rect[data-v-28c1a3bf] {\n  pointer-events: auto;\n}\n", ""]);

